import store from "./redux/store";

export const getProperty = (key: string, defaultValue: any) => getConfigProperty(key, defaultValue);

const getConfigProperty = (key: string, defaultValue: any) => {
  const config = store?.getState()?.commonServiceReducers?.fsConfigReducer?.config || {};
  return config[key] ?? defaultValue;
}

export const overrideConfig = (override: any) => {
  store.dispatch({ type: 'setConfig', response: override });
}

export const getHelpPage = () => store?.getState()?.commonServiceReducers?.fsConfigReducer?.helpPage || '';

export const getAlerts = () => store?.getState()?.commonServiceReducers?.fsConfigReducer?.alerts || [];

export const getSpinnerShow = () => store?.getState()?.spinnerReducer.show || false;
